<template>
  <v-dialog v-model="addCommentDialog" scrollable max-width="700px" persistent>
    <v-card>
      <v-toolbar color="white" fixed>
        
            <v-btn color="red" text fab small @click="closeCommentDialog" class="float-right"
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <h3>{{ $i18n.t("Add Comment") }}</h3>

      </v-toolbar>
      <v-card-text>
        <v-container dense>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" lg="12" md="12" sm="12">
                <v-select
                  v-model="comment.commentsFor"
                  :label="$i18n.t('Comment For') + '*'"
                  :items="[
                    { name: 'All', value: '0' },
                    { name: 'Driver', value: '1' },
                    { name: 'Admin', value: '2' },
                  ]"
                  item-text="name"
                  item-value="value"
                  required
                  :disabled="!!forHold"
                ></v-select>

                <!-- <v-checkbox
                  :label="$i18n.t('For Invoice')"
                  v-model="comment.forInvoice"
                ></v-checkbox> -->
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12">
                <v-text-field
                  v-model="comment.msg"
                  :label="$i18n.t('Type Comment Here')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        
        <v-spacer />
        <v-btn
          color="success darken-1"
          @click="returnComment()"
          :disabled="!comment.msg"
          >{{forHold ? $i18n.t('Add') : $i18n.t('Save')}}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "AddComment",
  props: {
    showCommentDialog: {
      default: null,
    },
    forHold: {
      default: null,
    },
  },
})
export default class AddComment extends (Vue, Themeable) {
  comment = { commentsFor: "2" };
  addCommentDialog = null;
  returnComment() {
    this.$emit("comment", this.comment);
    // this.closeCommentDialog();
  }
  closeCommentDialog() {
    this.$emit("closeCommentDialog", true);
  }

  @Watch("showCommentDialog")
  onDialogValChange(val) {
    this.addCommentDialog = val;
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
